module.exports = __webpack_public_path__ + "img/AI导诊.95fd8765.png";